var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZip = function SvgZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.5 10.5 18 6h4.5zM4.5 13h13.6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 9,
    x: 2.1,
    y: 11,
    fill: "#864283",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.354 17.5v-.502l1.996-2.8h-2V13.5h3.063v.502l-1.998 2.8h2.002v.698zm4.722-4v4h-.845v-4zm.861 4v-4h1.578q.456 0 .776.174.32.172.488.478.17.306.17.704t-.172.703q-.172.304-.498.474-.324.17-.785.17h-1.006v-.678h.869a.85.85 0 0 0 .402-.084.56.56 0 0 0 .239-.236.74.74 0 0 0 .08-.35.7.7 0 0 0-.08-.347.54.54 0 0 0-.239-.233.9.9 0 0 0-.406-.084h-.57V17.5z"
  })));
};
export default SvgZip;